import dayjs from 'dayjs';
import leftArrow from '../../assets/chevron-left.svg';
import rightArrow from '../../assets/chevron-right.svg';

interface DatePickerHeaderProps {
  increaseMonth: () => void;
  decreaseMonth: () => void;
  changeYear: (year: number) => void;
  date: Date;
}

const DatePickerHeader = ({
  increaseMonth,
  decreaseMonth,
  date,
  changeYear,
}: DatePickerHeaderProps) => (
  <div className='flex items-center justify-between gap-x-3 rounded-t-sm text-sm font-medium leading-5 bg-gray-100 mx-2'>
    <p className='ml-2 w-20 text-base text-left'>
      {dayjs(date).format('MMMM')}
    </p>
    <input
      type='number'
      className='w-20 border-transparent focus:border-transparent focus:ring-0 focus:bg-gray-200 bg-gray-100'
      value={date.getFullYear()}
      onChange={(e) => changeYear(parseInt(e.target.value))}
    />
    <div className='flex'>
      <div
        onClick={decreaseMonth}
        className='flex justify-center items-center w-8 h-10 hover:bg-gray-200'
      >
        <img
          src={leftArrow}
          alt='left arrow'
          width={20}
          height={20}
          className='cursor-pointer rounded-md'
          style={{ fill: 'blue' }}
        />
      </div>
      <div
        onClick={increaseMonth}
        className='flex justify-center items-center w-8 h-10 hover:bg-gray-200'
      >
        <img
          src={rightArrow}
          alt='right arrow'
          width={20}
          height={20}
          className='cursor-pointer rounded-md'
          style={{ fill: 'red' }}
        />
      </div>
    </div>
  </div>
);

export default DatePickerHeader;
